/* eslint-disable */
import {BaseInterfApi} from 'unityrpcjs/unityrpc.js'

import * as MisComm from "rpc/MisComm/MisComm"
import * as Login from "rpc/Login/Login"
import * as Comm from "rpc/Comm/Comm"
export var TYPE_CONTRACT_ALL = "all";
export var TYPE_CONTRACT_VALID = "valid";
export var TYPE_MESSAGE_ALL = "all";
export var TYPE_MESSAGE_UNREAD = "unread";
export var TYPE_MESSAGE_READED = "readed";
export var MESSAGE_CTYPE_ORDER = 1;
export var TYPE_ADDRESS_MANAGE = 2;
export var TYPE_DEPOSIT = 3;
export var CONTACT_REASON_ADDRESS_MANAGE = "address_manage";
export var DEFAULT_CONTACT_TYPE_SHOP = "shop";
export var DEFAULT_CONTACT_TYPE_CONTACT = "contact";

export class PointSkuBasic {
    constructor() {
        this.skuBasic = new MisComm.SkuBasic();  // 0 require
        this.points = 0;  // 1 require
        this.count = 0;  // 2 require
        this.exchangedCount = 0;  // 3 require
        this.beginDate = null;  // 4 require
        this.endDate = null;  // 5 require
        this.userLimit = 0;  // 6 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PointSkuBasic.__json_class__ = 'MisBuyer.PointSkuBasic'

export class PointSpuInfo {
    constructor() {
        this.spuBasic = new MisComm.SpuBasic();  // 0 require
        this.skuList = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PointSpuInfo.__json_class__ = 'MisBuyer.PointSpuInfo'

export class CompanyBasic {
    constructor() {
        this.companyid = 0;  // 0 require
        this.userid = 0;  // 1 require
        this.name = "";  // 2 require
        this.phone = "";  // 4 require
        this.mobile = "";  // 5 require
        this.email = "";  // 6 require
        this.logo = "";  // 7 require
        this.type = "";  // 8 require
        this.isBuyer = false;  // 9 require
        this.isSeller = false;  // 10 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CompanyBasic.__json_class__ = 'MisBuyer.CompanyBasic'

export class CartSku {
    constructor() {
        this.userid = 0;  // 0 require
        this.skuid = 0;  // 1 require
        this.count = 0;  // 2 require
        this.ss_name = "";  // 3 require
        this.ss_spec = "";  // 4 require
        this.ss_img = "";  // 5 require
        this.ss_price = 0;  // 6 require
        this.valid = false;  // 7 require
        this.seller_companyid = 0;  // 8 require
        this.ss_points = 0;  // 9 require
        this.ss_type = "";  // 10 require
        this.storeCount = 0;  // 11 require
        this.canSellCount = 0;  // 12 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CartSku.__json_class__ = 'MisBuyer.CartSku'

export class OrderBasic {
    constructor() {
        this.orderid = 0;  // 0 require
        this.buyer_userid = 0;  // 1 require
        this.buyer_companyid = 0;  // 2 require
        this.seller_companyid = 0;  // 3 require
        this.payMethod = "";  // 4 require
        this.payStatus = "";  // 5 require
        this.status = "";  // 6 require
        this.price = 0;  // 7 require
        this.create_time = null;  // 8 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderBasic.__json_class__ = 'MisBuyer.OrderBasic'

export class OrderBasicInfo {
    constructor() {
        this.order = new OrderBasic();  // 0 require
        this.buyerName = "";  // 1 require
        this.buyer_shopName = "";  // 2 require
        this.buyer_companyName = "";  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderBasicInfo.__json_class__ = 'MisBuyer.OrderBasicInfo'
export var FILTER_CHOICE = "choice";
export var FILTER_COMPLEMENT = "complement";
export var FILTER_RANGE = "range";
export var FILTER_VALUE = "value";
export var FIELD_TYPE_INT = "int";
export var FIELD_TYPE_STR = "str";
export var FIELD_TYPE_BOOL = "bool";
export var FIELD_TYPE_FLOAT = "float";
export var FIELD_TYPE_DATETIME = "datetime";
export var FIELD_TYPE_UNKNOWN = "unknown";

export class FilterSpec {
    constructor() {
        this.type = "";  // 0 require
        this.field = "";  // 1 require
        this.fieldType = "";  // 2 require
        this.title = "";  // 3 require
        this.valuesJson = "";  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

FilterSpec.__json_class__ = 'MisBuyer.FilterSpec'

export class SimpleQuerySpec {
    constructor() {
        this.filters = [];  // 0 require
        this.valueNameMap = {};  // 5 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SimpleQuerySpec.__json_class__ = 'MisBuyer.SimpleQuerySpec'

export class SimpleQuery {
    constructor() {
        this.filters = [];  // 0 require
        this.offset = 0;  // 1 require
        this.limit = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SimpleQuery.__json_class__ = 'MisBuyer.SimpleQuery'

export class CartMessage {
    constructor() {
        this.text = "";  // 0 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CartMessage.__json_class__ = 'MisBuyer.CartMessage'

export class ContractSku {
    constructor() {
        this.contractid = 0;  // 0 require
        this.skuid = 0;  // 1 require
        this.ss_name = "";  // 2 require
        this.ss_spec = "";  // 3 require
        this.ss_unitName = "";  // 4 require
        this.ss_price = 0;  // 5 require
        this.ss_img = "";  // 6 require
        this.negotiate = 0;  // 7 require
        this.negotiateExpire = 0;  // 8 require
        this.negotiateType = "";  // 9 require
        this.price = 0;  // 10 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ContractSku.__json_class__ = 'MisBuyer.ContractSku'

export class ContractInfo {
    constructor() {
        this.appid = "";  // 0 require
        this.contract = new MisComm.Contract();  // 1 require
        this.contractSkus = [];  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ContractInfo.__json_class__ = 'MisBuyer.ContractInfo'

export class ContractDetail {
    constructor() {
        this.contract = new MisComm.Contract();  // 0 require
        this.contractSkus = [];  // 1 require
        this.clauseText = "";  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ContractDetail.__json_class__ = 'MisBuyer.ContractDetail'

export class OrderAfterSale {
    constructor() {
        this.orderid = 0;  // 0 require
        this.status = "";  // 1 require
        this.reason = "";  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderAfterSale.__json_class__ = 'MisBuyer.OrderAfterSale'

export class CardTempInfo {
    constructor() {
        this.mobile = "";  // 0 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CardTempInfo.__json_class__ = 'MisBuyer.CardTempInfo'

export class Config {
    constructor() {
        this.appid = "";  // 0 require
        this.vip_cardid = "";  // 1 require
        this.company_cardid = "";  // 2 require
        this.platform_company_cardid = "";  // 3 require
        this.platform_user_cardid = "";  // 4 require
        this.version = "";  // 5 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

Config.__json_class__ = 'MisBuyer.Config'

export class Card {
    constructor() {
        this.membership_number = "";  // 0 require
        this.wx_unionid = "";  // 1 require
        this.wx_openid = "";  // 2 require
        this.wx_cardid = "";  // 3 require
        this.points = -1;  // 4 require
        this.mobile = "";  // 5 require
        this.create_time = null;  // 6 require
        this.seller_companyid = 0;  // 7 require
        this.experience = -1;  // 8 require
        this.consumedBalance = -1;  // 9 require
        this.consumedPoints = -1;  // 10 require
        this.balance = -1;  // 11 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

Card.__json_class__ = 'MisBuyer.Card'

export class Message {
    constructor() {
        this.id = 0;  // 0 require
        this.userid = 0;  // 1 require
        this.ctype = 0;  // 2 require
        this.to_userid = 0;  // 3 require
        this.was_read = false;  // 4 require
        this.was_read_at = null;  // 5 require
        this.topic = "";  // 6 require
        this.message = "";  // 7 require
        this.create_time = null;  // 8 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

Message.__json_class__ = 'MisBuyer.Message'

export class BillBar {
    constructor() {
        this.month = null;  // 0 require
        this.billPrice = 0;  // 1 require
        this.orderCount = 0;  // 2 require
        this.accountcredit = 0;  // 3 require
        this.repayment = 0;  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

BillBar.__json_class__ = 'MisBuyer.BillBar'

export class BillBrief {
    constructor() {
        this.billPriceMonth = null;  // 0 require
        this.billPrice = 0;  // 1 require
        this.debt = 0;  // 2 require
        this.debtInterest = 0;  // 3 require
        this.repaymentNotCounted = 0;  // 4 require
        this.shouldPayPrice = 0;  // 5 require
        this.lastBillPriceMonth = null;  // 6 require
        this.lastBillPrice = 0;  // 7 require
        this.avgBillPrice = 0;  // 8 require
        this.avgOrderCount = 0;  // 9 require
        this.avgAccountcredit = 0;  // 10 require
        this.halfYearOrderCount = 0;  // 11 require
        this.orderCount = 0;  // 12 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

BillBrief.__json_class__ = 'MisBuyer.BillBrief'

export class BuyerBillBrief {
    constructor() {
        this.buyer_company = new CompanyBasic();  // 0 require
        this.seller_companies = [];  // 1 require
        this.brief = new BillBrief();  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

BuyerBillBrief.__json_class__ = 'MisBuyer.BuyerBillBrief'

export class BuyerSellerBillBrief {
    constructor() {
        this.buyer_company = new CompanyBasic();  // 0 require
        this.seller_company = new CompanyBasic();  // 1 require
        this.brief = new BillBrief();  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

BuyerSellerBillBrief.__json_class__ = 'MisBuyer.BuyerSellerBillBrief'

export class Company {
    constructor() {
        this.companyid = 0;  // 0 require
        this.userid = 0;  // 1 require
        this.name = "";  // 2 require
        this.phone = "";  // 4 require
        this.mobile = "";  // 5 require
        this.email = "";  // 6 require
        this.logo = "";  // 7 require
        this.type = "";  // 8 require
        this.isBuyer = false;  // 9 require
        this.isSeller = false;  // 10 require
        this.desc = "";  // 11 require
        this.license = "";  // 12 require
        this.bankOpening = "";  // 13 require
        this.bankAccount = "";  // 14 require
        this.legalPersonName = "";  // 15 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

Company.__json_class__ = 'MisBuyer.Company'

export class Shop {
    constructor() {
        this.shopid = 0;  // 0 require
        this.code = "";  // 1 require
        this.userid = 0;  // 2 require
        this.companyid = 0;  // 3 require
        this.name = "";  // 4 require
        this.phone = "";  // 6 require
        this.mobile = "";  // 7 require
        this.email = "";  // 8 require
        this.desc = "";  // 9 require
        this.province = "";  // 10 require
        this.city = "";  // 11 require
        this.district = "";  // 12 require
        this.address = "";  // 13 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

Shop.__json_class__ = 'MisBuyer.Shop'

export class WxOauthAccessToken {
    constructor() {
        this.access_token = "";  // 0 require
        this.expires_in = 0;  // 1 require
        this.refresh_token = "";  // 3 require
        this.openid = "";  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

WxOauthAccessToken.__json_class__ = 'MisBuyer.WxOauthAccessToken'

export class ShopBillBar {
    constructor() {
        this.shopid = 0;  // 0 require
        this.address = "";  // 2 require
        this.name = "";  // 3 require
        this.userName = "";  // 5 require
        this.userMobile = "";  // 6 require
        this.billBar = new BillBar();  // 7 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ShopBillBar.__json_class__ = 'MisBuyer.ShopBillBar'
export var TABLE_SPEC_SelectBuyOrder = "SelectBuyOrder";
export var TABLE_SPEC_PayOrder = "PayOrder";
export var TABLE_SPEC_BuyerBillSummary = "BuyerBillSummary";
export var TABLE_SPEC_BuyerBill = "BuyerBill";
export var TABLE_SPEC_BuyerBillDetail = "BuyerBillDetail";
export var TABLE_SPEC_BuyerDebtDetail = "BuyerDebtDetail";
export var TABLE_SPEC_BuyerInterestDetail = "BuyerInterestDetail";
export var TABLE_SPEC_BuyerRepaymentDetail = "BuyerRepaymentDetail";
export var TABLE_SPEC_BuyerContract = "BuyerContract";
export var TABLE_SPEC_BuyerContractSku = "BuyerContractSku";
export var TABLE_SPEC_Supplier = "Supplier";
export var FORM_SPEC_BuyPayment = "BuyPayment";

export class TodayOrderStat {
    constructor() {
        this.allWillPayCount = 0;  // 0 require
        this.todayPayCount = 0;  // 1 require
        this.todayOrderCount = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

TodayOrderStat.__json_class__ = 'MisBuyer.TodayOrderStat'

export class PointOrderIn {
    constructor() {
        this.skuid = 0;  // 0 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PointOrderIn.__json_class__ = 'MisBuyer.PointOrderIn'

export class BuyerCustomSkusInfo {
    constructor() {
        this.customBasic = new MisComm.CustomBasic();  // 0 require
        this.skuInfos = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

BuyerCustomSkusInfo.__json_class__ = 'MisBuyer.BuyerCustomSkusInfo'

export class BuyerMallSku {
    constructor() {
        this.userid = 0;  // 0 require
        this.skuid = 0;  // 1 require
        this.count = 0;  // 2 require
        this.ss_name = "";  // 3 require
        this.ss_spec = "";  // 4 require
        this.ss_img = "";  // 5 require
        this.ss_price = 0;  // 6 require
        this.checked = false;  // 7 require
        this.customid = 0;  // 8 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

BuyerMallSku.__json_class__ = 'MisBuyer.BuyerMallSku'

export class BuyerCustomIn {
    constructor() {
        this.customid = 0;  // 0 require
        this.name = "";  // 1 require
        this.contactName = "";  // 2 require
        this.contactMobile = "";  // 3 require
        this.province = "";  // 4 require
        this.city = "";  // 5 require
        this.district = "";  // 6 require
        this.address = "";  // 7 require
        this.cateid = 0;  // 8 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

BuyerCustomIn.__json_class__ = 'MisBuyer.BuyerCustomIn'

export class BuyerOrderIn {
    constructor() {
        this.orderIn = new MisComm.OrderIn();  // 0 require
        this.buyer_customid = 0;  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

BuyerOrderIn.__json_class__ = 'MisBuyer.BuyerOrderIn'

export class UpdateBuyerMallSkuIn {
    constructor() {
        this.skuid = 0;  // 0 require
        this.customid = 0;  // 1 require
        this.checked = false;  // 2 require
        this.count = 0;  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

UpdateBuyerMallSkuIn.__json_class__ = 'MisBuyer.UpdateBuyerMallSkuIn'

export class QueryCustomSpuIn {
    constructor() {
        this.spuName = "";  // 0 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

QueryCustomSpuIn.__json_class__ = 'MisBuyer.QueryCustomSpuIn'

export class QueryCustomSpuInfo {
    constructor() {
        this.customSpuInfos = [];  // 0 require
        this.ownedSpuInfos = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

QueryCustomSpuInfo.__json_class__ = 'MisBuyer.QueryCustomSpuInfo'

export class SkuBuyPriceItem {
    constructor() {
        this.custom = new MisComm.CustomBasic();  // 0 require
        this.buyPrice = 0;  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SkuBuyPriceItem.__json_class__ = 'MisBuyer.SkuBuyPriceItem'
export var TARGET_ROLE_BUYER = "buyer";
export var TARGET_ROLE_DISTRIBUTOR = "distributor";
export var PRICE_TYPE_COMPANY = "company";
export var PRICE_TYPE_CUSTOM = "custom";

export class CustomCompanyConfig {
    constructor() {
        this.target_role = "";  // 0 require
        this.priceType = "";  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomCompanyConfig.__json_class__ = 'MisBuyer.CustomCompanyConfig'

export class UpdateBuyPriceIn {
    constructor() {
        this.skuid = 0;  // 0 require
        this.customid = 0;  // 1 require
        this.buyPrice = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

UpdateBuyPriceIn.__json_class__ = 'MisBuyer.UpdateBuyPriceIn'

export class SearchBuyerCustomSpuIn {
    constructor() {
        this.keyword = "";  // 0 require
        this.customid = 0;  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SearchBuyerCustomSpuIn.__json_class__ = 'MisBuyer.SearchBuyerCustomSpuIn'

export class CustomSimpleInfo {
    constructor() {
        this.customid = 0;  // 0 require
        this.name = "";  // 1 require
        this.companyid = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomSimpleInfo.__json_class__ = 'MisBuyer.CustomSimpleInfo'

export class MisBuyerInterfApi extends BaseInterfApi {
    constructor(baseUrl, moduleName='MisBuyer',
            interfName='MisBuyerInterf', token='anonymous', ...args) {
        super(baseUrl, moduleName, interfName, token, ...args)
    }


    getBuyerContactList( context) {
        let params = {
            };
        let req = this.createRequest('getBuyerContactList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerContactList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerShopContactList( context) {
        let params = {
            };
        let req = this.createRequest('getBuyerShopContactList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerShopContactList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    addBuyerContact(contact, context) {
        let params = {
            contact: contact,
            };
        let req = this.createRequest('addBuyerContact', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('addBuyerContact'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    delBuyerContact(contactUUID, context) {
        let params = {
            contactUUID: contactUUID,
            };
        let req = this.createRequest('delBuyerContact', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('delBuyerContact'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateBuyerContact(contact, context) {
        let params = {
            contact: contact,
            };
        let req = this.createRequest('updateBuyerContact', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateBuyerContact'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerContact(contactUUID, context) {
        let params = {
            contactUUID: contactUUID,
            };
        let req = this.createRequest('getBuyerContact', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerContact'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    setBuyerDefaultContact(type,id, context) {
        let params = {
            type: type,
            id: id,
            };
        let req = this.createRequest('setBuyerDefaultContact', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('setBuyerDefaultContact'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    contactMeLater(reason, context) {
        let params = {
            reason: reason,
            };
        let req = this.createRequest('contactMeLater', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('contactMeLater'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCompany(companyid, context) {
        let params = {
            companyid: companyid,
            };
        let req = this.createRequest('getCompany', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCompany'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getShop(shopid, context) {
        let params = {
            shopid: shopid,
            };
        let req = this.createRequest('getShop', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getShop'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getShops( context) {
        let params = {
            };
        let req = this.createRequest('getShops', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getShops'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    bindShops(shopids, context) {
        let params = {
            shopids: shopids,
            };
        let req = this.createRequest('bindShops', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('bindShops'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderInfoList(status,pageIn, context) {
        let params = {
            status: status,
            pageIn: pageIn,
            };
        let req = this.createRequest('getOrderInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBatchOrderInfoList(pageIn, context) {
        let params = {
            pageIn: pageIn,
            };
        let req = this.createRequest('getBatchOrderInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBatchOrderInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderInfoListByIds(orderids, context) {
        let params = {
            orderids: orderids,
            };
        let req = this.createRequest('getOrderInfoListByIds', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderInfoListByIds'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPointOrderInfoList(status,pageIn, context) {
        let params = {
            status: status,
            pageIn: pageIn,
            };
        let req = this.createRequest('getPointOrderInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPointOrderInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    createOrder(orderIn, context) {
        let params = {
            orderIn: orderIn,
            };
        let req = this.createRequest('createOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('createOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    createPointOrder(pointOrderIn, context) {
        let params = {
            pointOrderIn: pointOrderIn,
            };
        let req = this.createRequest('createPointOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('createPointOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    cancelOrder(orderid, context) {
        let params = {
            orderid: orderid,
            };
        let req = this.createRequest('cancelOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('cancelOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    auditOrder(orderids, context) {
        let params = {
            orderids: orderids,
            };
        let req = this.createRequest('auditOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('auditOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    reauditOrder(orderids, context) {
        let params = {
            orderids: orderids,
            };
        let req = this.createRequest('reauditOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('reauditOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    returnOrder(orderids, context) {
        let params = {
            orderids: orderids,
            };
        let req = this.createRequest('returnOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('returnOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    checkOrder(orderIdInfo, context) {
        let params = {
            orderIdInfo: orderIdInfo,
            };
        let req = this.createRequest('checkOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('checkOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    confirmOrderReceipt(orderids, context) {
        let params = {
            orderids: orderids,
            };
        let req = this.createRequest('confirmOrderReceipt', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('confirmOrderReceipt'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    commitOrderAfterSale(info, context) {
        let params = {
            info: info,
            };
        let req = this.createRequest('commitOrderAfterSale', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('commitOrderAfterSale'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderRedPoint( context) {
        let params = {
            };
        let req = this.createRequest('getOrderRedPoint', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderRedPoint'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    searchOrder(searchIn,pageIn, context) {
        let params = {
            searchIn: searchIn,
            pageIn: pageIn,
            };
        let req = this.createRequest('searchOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('searchOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    accountCreditPay(orderid, context) {
        let params = {
            orderid: orderid,
            };
        let req = this.createRequest('accountCreditPay', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('accountCreditPay'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    searchMallSpu(searchIn,pageIn, context) {
        let params = {
            searchIn: searchIn,
            pageIn: pageIn,
            };
        let req = this.createRequest('searchMallSpu', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('searchMallSpu'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getServicePhone( context) {
        let params = {
            };
        let req = this.createRequest('getServicePhone', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getServicePhone'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateCartSku(skuid,count, context) {
        let params = {
            skuid: skuid,
            count: count,
            };
        let req = this.createRequest('updateCartSku', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateCartSku'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCartSkuList( context) {
        let params = {
            };
        let req = this.createRequest('getCartSkuList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCartSkuList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCartMessages(skuids, context) {
        let params = {
            skuids: skuids,
            };
        let req = this.createRequest('getCartMessages', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCartMessages'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    delCartSkuBatch(skuids, context) {
        let params = {
            skuids: skuids,
            };
        let req = this.createRequest('delCartSkuBatch', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('delCartSkuBatch'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerContractList(type, context) {
        let params = {
            type: type,
            };
        let req = this.createRequest('getBuyerContractList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerContractList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerContractInfoList(type, context) {
        let params = {
            type: type,
            };
        let req = this.createRequest('getBuyerContractInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerContractInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerContractDetail(contractid, context) {
        let params = {
            contractid: contractid,
            };
        let req = this.createRequest('getBuyerContractDetail', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerContractDetail'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getWxAcccessToken(code, context) {
        let params = {
            code: code,
            };
        let req = this.createRequest('getWxAcccessToken', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getWxAcccessToken'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getWxCardTempInfo(activate_ticket, context) {
        let params = {
            activate_ticket: activate_ticket,
            };
        let req = this.createRequest('getWxCardTempInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getWxCardTempInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    activateWxCard(openid,cardid,code, context) {
        let params = {
            openid: openid,
            cardid: cardid,
            code: code,
            };
        let req = this.createRequest('activateWxCard', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('activateWxCard'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    wxjsGetCardSignature(paramsJson, context) {
        let params = {
            paramsJson: paramsJson,
            };
        let req = this.createRequest('wxjsGetCardSignature', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('wxjsGetCardSignature'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    wxjsGetApiSignature(paramsJson, context) {
        let params = {
            paramsJson: paramsJson,
            };
        let req = this.createRequest('wxjsGetApiSignature', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('wxjsGetApiSignature'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCard(cardid, context) {
        let params = {
            cardid: cardid,
            };
        let req = this.createRequest('getCard', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCard'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getConfig( context) {
        let params = {
            };
        let req = this.createRequest('getConfig', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getConfig'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getMessageList(type,pageIn, context) {
        let params = {
            type: type,
            pageIn: pageIn,
            };
        let req = this.createRequest('getMessageList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getMessageList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getMessageById(id, context) {
        let params = {
            id: id,
            };
        let req = this.createRequest('getMessageById', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getMessageById'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    setReadMessage(id, context) {
        let params = {
            id: id,
            };
        let req = this.createRequest('setReadMessage', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('setReadMessage'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getMessageCount(type, context) {
        let params = {
            type: type,
            };
        let req = this.createRequest('getMessageCount', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getMessageCount'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBillBars(buyer_companyid,seller_companyid,pageIn, context) {
        let params = {
            buyer_companyid: buyer_companyid,
            seller_companyid: seller_companyid,
            pageIn: pageIn,
            };
        let req = this.createRequest('getBillBars', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBillBars'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerBillBrief(buyer_companyid, context) {
        let params = {
            buyer_companyid: buyer_companyid,
            };
        let req = this.createRequest('getBuyerBillBrief', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerBillBrief'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerSellerBillBrief(buyer_companyid,seller_companyid, context) {
        let params = {
            buyer_companyid: buyer_companyid,
            seller_companyid: seller_companyid,
            };
        let req = this.createRequest('getBuyerSellerBillBrief', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerSellerBillBrief'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getShopBillBrief(buyer_companyid, context) {
        let params = {
            buyer_companyid: buyer_companyid,
            };
        let req = this.createRequest('getShopBillBrief', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getShopBillBrief'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderQuerySpec( context) {
        let params = {
            };
        let req = this.createRequest('getOrderQuerySpec', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderQuerySpec'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    queryOrderBasicInfoList(query, context) {
        let params = {
            query: query,
            };
        let req = this.createRequest('queryOrderBasicInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('queryOrderBasicInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPointSpuInfoList( context) {
        let params = {
            };
        let req = this.createRequest('getPointSpuInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPointSpuInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getECardList( context) {
        let params = {
            };
        let req = this.createRequest('getECardList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getECardList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    bindECard(password, context) {
        let params = {
            password: password,
            };
        let req = this.createRequest('bindECard', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('bindECard'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getTodayOrderStat( context) {
        let params = {
            };
        let req = this.createRequest('getTodayOrderStat', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getTodayOrderStat'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSpuDetail(spuid, context) {
        let params = {
            spuid: spuid,
            };
        let req = this.createRequest('getSpuDetail', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSpuDetail'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getMallTabSpuInfoList(tabid,type, context) {
        let params = {
            tabid: tabid,
            type: type,
            };
        let req = this.createRequest('getMallTabSpuInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getMallTabSpuInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getMallTabSpuInfoPageList(tabid,type,pageIn, context) {
        let params = {
            tabid: tabid,
            type: type,
            pageIn: pageIn,
            };
        let req = this.createRequest('getMallTabSpuInfoPageList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getMallTabSpuInfoPageList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getGroupSpuInfoList(skuGroupid, context) {
        let params = {
            skuGroupid: skuGroupid,
            };
        let req = this.createRequest('getGroupSpuInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getGroupSpuInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getLastOrderSkuList( context) {
        let params = {
            };
        let req = this.createRequest('getLastOrderSkuList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getLastOrderSkuList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    batchCreateOrder(orderIns, context) {
        let params = {
            orderIns: orderIns,
            };
        let req = this.createRequest('batchCreateOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('batchCreateOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getAllBuyerCustomSkusList( context) {
        let params = {
            };
        let req = this.createRequest('getAllBuyerCustomSkusList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getAllBuyerCustomSkusList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerCustomSkuList(buyer_customid,pageIn, context) {
        let params = {
            buyer_customid: buyer_customid,
            pageIn: pageIn,
            };
        let req = this.createRequest('getBuyerCustomSkuList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerCustomSkuList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateOrCreateBuyerCustom(customIn, context) {
        let params = {
            customIn: customIn,
            };
        let req = this.createRequest('updateOrCreateBuyerCustom', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateOrCreateBuyerCustom'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    inactivateBuyerCustom(customid, context) {
        let params = {
            customid: customid,
            };
        let req = this.createRequest('inactivateBuyerCustom', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('inactivateBuyerCustom'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateOrCreateBuyerSku(skuIn, context) {
        let params = {
            skuIn: skuIn,
            };
        let req = this.createRequest('updateOrCreateBuyerSku', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateOrCreateBuyerSku'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    inactivateBuyerSku(skuid,customid, context) {
        let params = {
            skuid: skuid,
            customid: customid,
            };
        let req = this.createRequest('inactivateBuyerSku', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('inactivateBuyerSku'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    addBuyerSkuFile(buyer_customid,ftype,uri, context) {
        let params = {
            buyer_customid: buyer_customid,
            ftype: ftype,
            uri: uri,
            };
        let req = this.createRequest('addBuyerSkuFile', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('addBuyerSkuFile'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerMallTabList( context) {
        let params = {
            };
        let req = this.createRequest('getBuyerMallTabList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerMallTabList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerMallSpuInfoList(cateid,type, context) {
        let params = {
            cateid: cateid,
            type: type,
            };
        let req = this.createRequest('getBuyerMallSpuInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerMallSpuInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerMallSpuInfoPageList(cateid,type,pageIn, context) {
        let params = {
            cateid: cateid,
            type: type,
            pageIn: pageIn,
            };
        let req = this.createRequest('getBuyerMallSpuInfoPageList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerMallSpuInfoPageList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    queryBuyerCustomSpu(customid,queryIn, context) {
        let params = {
            customid: customid,
            queryIn: queryIn,
            };
        let req = this.createRequest('queryBuyerCustomSpu', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('queryBuyerCustomSpu'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerCustomSpuDetail(customid,skuid, context) {
        let params = {
            customid: customid,
            skuid: skuid,
            };
        let req = this.createRequest('getBuyerCustomSpuDetail', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerCustomSpuDetail'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateBuyerMallSkuStatus(updateSkuIn, context) {
        let params = {
            updateSkuIn: updateSkuIn,
            };
        let req = this.createRequest('updateBuyerMallSkuStatus', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateBuyerMallSkuStatus'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerMallSkuStatusList( context) {
        let params = {
            };
        let req = this.createRequest('getBuyerMallSkuStatusList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerMallSkuStatusList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    clearBuyerMallSkuStatus( context) {
        let params = {
            };
        let req = this.createRequest('clearBuyerMallSkuStatus', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('clearBuyerMallSkuStatus'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBuyerCustomList( context) {
        let params = {
            };
        let req = this.createRequest('getBuyerCustomList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBuyerCustomList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    bindBuyerCustom(customid, context) {
        let params = {
            customid: customid,
            };
        let req = this.createRequest('bindBuyerCustom', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('bindBuyerCustom'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSkuBuyPriceList(skuid, context) {
        let params = {
            skuid: skuid,
            };
        let req = this.createRequest('getSkuBuyPriceList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSkuBuyPriceList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateSkuBuyPrice(updateIn, context) {
        let params = {
            updateIn: updateIn,
            };
        let req = this.createRequest('updateSkuBuyPrice', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateSkuBuyPrice'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    searchBuyerCustom(keyword,pageIn, context) {
        let params = {
            keyword: keyword,
            pageIn: pageIn,
            };
        let req = this.createRequest('searchBuyerCustom', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('searchBuyerCustom'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    searchBuyerCustomSpu(searchIn,pageIn, context) {
        let params = {
            searchIn: searchIn,
            pageIn: pageIn,
            };
        let req = this.createRequest('searchBuyerCustomSpu', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('searchBuyerCustomSpu'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    createPriceSheet(priceSheetIn, context) {
        let params = {
            priceSheetIn: priceSheetIn,
            };
        let req = this.createRequest('createPriceSheet', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('createPriceSheet'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updatePriceSheet(priceSheetIn, context) {
        let params = {
            priceSheetIn: priceSheetIn,
            };
        let req = this.createRequest('updatePriceSheet', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updatePriceSheet'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    deletePriceSheet(sheetid, context) {
        let params = {
            sheetid: sheetid,
            };
        let req = this.createRequest('deletePriceSheet', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('deletePriceSheet'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPriceSheetList(pageIn, context) {
        let params = {
            pageIn: pageIn,
            };
        let req = this.createRequest('getPriceSheetList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPriceSheetList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPriceSheetInfo(sheetid, context) {
        let params = {
            sheetid: sheetid,
            };
        let req = this.createRequest('getPriceSheetInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPriceSheetInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPriceSheetDetail(sheetid, context) {
        let params = {
            sheetid: sheetid,
            };
        let req = this.createRequest('getPriceSheetDetail', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPriceSheetDetail'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getMallCompanyList(pageIn, context) {
        let params = {
            pageIn: pageIn,
            };
        let req = this.createRequest('getMallCompanyList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getMallCompanyList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderLimit( context) {
        let params = {
            };
        let req = this.createRequest('getOrderLimit', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderLimit'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCustomCompanyConfig( context) {
        let params = {
            };
        let req = this.createRequest('getCustomCompanyConfig', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCustomCompanyConfig'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSellerCustomList( context) {
        let params = {
            };
        let req = this.createRequest('getSellerCustomList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSellerCustomList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCustomsByUserAndSeller( context) {
        let params = {
            };
        let req = this.createRequest('getCustomsByUserAndSeller', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCustomsByUserAndSeller'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCustomsByUserCompanyAndSeller( context) {
        let params = {
            };
        let req = this.createRequest('getCustomsByUserCompanyAndSeller', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCustomsByUserCompanyAndSeller'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    createSellerCustom(shopid, context) {
        let params = {
            shopid: shopid,
            };
        let req = this.createRequest('createSellerCustom', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('createSellerCustom'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/apis/rpc/MisBuyer/MisBuyer.js